<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap fill-height>
        <v-flex xs12 lg6 class="head_contain">
          <p class="table_card__head--title">
            Formularios creados
          </p>
        </v-flex>
        <v-flex xs12 lg6 class="filter_options">
          <v-flex class="right mr-20">
            <button
              class="faccess_button"
              @click="$router.push({name: 'new_form'})"
            >
              Crear nuevo Formulario
            </button>
          </v-flex>
          <div
            class="buttom_reload"
            @click="findOffers()"
          >
            <img src="@/assets/img/icons/refresh-icon.svg">
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__body pb-0" style="padding-left: 0px">
        <v-data-table
             
              :headers="options_table.headers_table"
              :items="forms"
              :search="options_table.search"
              :pagination.sync="options_table.pagination"
              select-all
            >
            <!--  slot="headers" -->
              <template slot="headers" slot-scope="props">
                <tr>
                  <th
                    v-for="header in options_table.headers_table"
                    :key="header.text"
                  >
                    <div v-if="options_table.filters.hasOwnProperty(header.value)">
                      <v-select v-if="columnValueList(header.value)[0]!=null" flat hide-details small multiple clearable :items="columnValueList(header.value)" v-model="options_table.filters[header.value]" :placeholder="header.text">
                      </v-select>
                    </div>
                  </th>
                </tr>
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)"
                  >
                    <v-icon small>arrow_upward</v-icon>
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <tr class="primary_color">
                  <td class="text-xs-center" style="width: 300px; padding: 0 0px;"><strong>{{ props.item.form_type.form_type }}</strong></td>
                  <td class="text-xs-center email" style="padding: 0 0px;">{{ props.item.form_name }}</td>
                  <td class="text-xs-center email" style="padding: 0 0px;">{{ props.item.state }}</td>
                  <td class="text-xs-center email" style="padding: 0 0px;">

                      <button v-if="props.item.form_state_id != 1"
                      class="faccess_button px-2"
                      style="height: 40px;display: inline-block;"
                      @click="activateForm(props.item)"
                    >
                        Enviar
                    </button>
                
                      <button
                      class="faccess_button px-2"
                      style="height: 40px;display: inline-block;"
                      @click="resultForm(props.item)"
                    >
                        Resultados
                    </button>
                  

 
                  </td>


                </tr>
              </template>
            </v-data-table>
    </div>
  </div>
</template>

<script>

export default {
  data(){
    return{
      forms:[],
      offers:[],
      images: [],
      hover: {
        edit: false,
        delete: false
      },

       options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10
        },
        headers_table:[
          {
            text: 'Tipo de formulario',
            align: 'center',
            value: 'email'
          },
          {
            text: 'Nombre del formulario',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Estado',
            align: 'center',
            value: 'name'
          },
          {
            text: 'Acción',
            align: 'center',
            value: 'name'
          },

        ],
        filters: {
          gender: [],
          location_name: [],
          age: [],
          access_state:[]
        },
      },
    }
  },

  methods:{

    prueba(){


      console.log('prueba')

            try{

         const data={ user:"admin", pass:"Puma2022.", position: 0, maxResult:100}
      this.$http.post('hikvision/getDevices',{data:this.encrypt(data).toString()},{headers:
        {"X-Device-ID" : this.getDeviceId(),
         "Authorization" : 'Bearer ' + this.getUserToken()}})
      .then(function(response){
        
        console.log('get devices',response)   

      }, function(response){
        
      })
      } catch (e) {
        alert(e.message)
      }


    },

    resultForm(form){

      var form_id = form.id


       this.$http.get('forms/result_form',
        {
          headers: {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken(),
          },
          params:{
            form_id: form_id,
          },
          responseType: 'blob'
        }).then((response) => {
                var format_type = response.data.type
                var type = format_type.split('/')

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'resultados.xlsx');
                document.body.appendChild(link);
                link.click();

                });


    },


    activateForm(form){

      var form_id = form.id

      try{

         const data={ form_id:form_id}
      this.$http.post('forms/activate_form',{data:this.encrypt(data).toString()},{headers:
        {"X-Device-ID" : this.getDeviceId(),
         "Authorization" : 'Bearer ' + this.getUserToken()}})
      .then(function(response){
        
        this.updateAlertMessage(response.body.msg);
        this.updateIsInAlert(true);
         this.getForms()       

      }, function(response){
        
      })
      } catch (e) {
        alert(e.message)
      }

      
    },

    getForms(){


         try {

      const data={id_company:this.getCompany().id}
      this.$http.post('forms/get_forms',{data:this.encrypt(data).toString()},{headers:
        {"X-Device-ID" : this.getDeviceId(),
         "Authorization" : 'Bearer ' + this.getUserToken()}})
      .then(function(response){
        
        var res = response.body.data
            this.forms = res.map(function (data) {
              data.hoover = false
              return data
            })

        console.info('forms',this.forms)    

      }, function(response){
        
      })
      } catch (e) {
        alert(e.message)
      }

    },


    Hoover(data, state){
        // console.log('data', data)
        console.log('state', state)

        var form = this.forms.find(item => item.id == data.id) 
        form.hoover = state

        console.log('form', form)

    }
  },
  mounted(){
    this.getForms()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/forms/Index.vue